import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {Event} from '../models/event';
import {Observable} from 'rxjs';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {AngularFireStorageReference, AngularFireUploadTask, AngularFireStorage} from '@angular/fire/compat/storage';
import {finalize} from 'rxjs/operators';
import {Guid} from "guid-typescript";
import {FileMaterial} from '../models/file-material';
import {ProductService} from './product.service';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  public currentEvent: Event;

  public isEdit: boolean = false;
  public localTitle: string;
  public spinner: boolean = false;

  private itemDoc: AngularFirestoreDocument<Event>;
  private item: Observable<Event>;

  public eventDataSource: MatTableDataSource<any>;

  public pdfDataSource: MatTableDataSource<any>
  public selectedFile: any = "Nenhum arquivo selecionado.";
  public objectPdf: any = "none";

  public arrayAllEvents: any[] = []; // armazena todos os eventos programados

  public docUsers: any;
  public docStaff: any;

  public isCongress: boolean;
  public isDeleted: boolean;

  public objectImage_web: any = null;
  public storedImage_web: any;

  public objectImage_mobile: any = null;
  public storedImage_mobile: any;

  constructor (
    private fb: FormBuilder,
    private fs: AngularFireStorage,
    private db: AngularFirestore,
    private snackBar: SnackBarIconService,
    public _productService: ProductService
  ) { }

  setEdit (): any {
    if (this.currentEvent.id) {
      this.isEdit = true
      this.localTitle = this.currentEvent.name
    } else {
      this.isEdit = false;
      if (this.currentEvent.congress)
        this.localTitle = "Novo Congresso"
      else
        this.localTitle = "Novo Evento"

    }
  }

  setPdfDataSource () {
    this.pdfDataSource = new MatTableDataSource(this.currentEvent.materials)
  }

  select (paginator, isCongress: boolean, isDeleted: boolean = false) {

    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('congress', '==', isCongress)
      .where('deleted', '==', isDeleted)
      .where('deleted', '==', isDeleted)
      .orderBy('startDay', 'desc')
      .orderBy('name', 'asc')
    ).snapshotChanges()
      .subscribe((result) => {
        let array: any[] = []
        result.forEach((item) => {

          const annuity = item.payload.doc.data().annuity ? true : false

          if (!annuity) {
            let event = new Event();
            event.id = item.payload.doc.id;
            event.name = item.payload.doc.data().name;
            event.key = item.payload.doc.data().key || '';
            event.master = item.payload.doc.data().master || false;
            event.belongsToProduct = item.payload.doc.data().belongsToProduct || false;
            event.location = item.payload.doc.data().location;
            event.location_id = item.payload.doc.data().location_id || '';
            event.context_id = item.payload.doc.data().context_id || '';
            event.text = item.payload.doc.data().text;
            event.deleted = item.payload.doc.data().deleted;
            event.congress = item.payload.doc.data().congress;
            event.materials = item.payload.doc.data().materials;
            event.limit_per_member = item.payload.doc.data().limit_per_member;

            event.control_ticket_by_topic = item.payload.doc.data().control_ticket_by_topic;

            event.docUsers = item.payload.doc.data().docUsers;
            event.docUserTop = item.payload.doc.data().docUserTop;
            event.docUserLeft = item.payload.doc.data().docUserLeft;

            event.docStaff = item.payload.doc.data().docStaff;

            event.sponsors = item.payload.doc.data().sponsors;

            event.urlQRCodeUser = item.payload.doc.data().urlQRCodeUser;
            event.urlQRCodeStaff = item.payload.doc.data().urlQRCodeStaff;

            event.image_web = item.payload.doc.data().image_web;
            event.image_mobile = item.payload.doc.data().image_mobile;

            if (item.payload.doc.data().startDay) {
              let dtStart: any = item.payload.doc.data().startDay
              event.startDay = new Date(dtStart.seconds * 1000);
            }
            array.push(event);
          }
        })

        this.eventDataSource = new MatTableDataSource(array);
        if (paginator)
          this.eventDataSource.paginator = paginator;
      })
  }

  selectByContext (context_id) {

    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('congress', '==', true)
      //.where('deleted', '==', false)
      .where('context_id', '==', context_id)
      .orderBy('name', 'asc')
    ).snapshotChanges()
      .subscribe((result) => {

        let array = result.map(item => {

          //console.log(" item.payload.doc.data().name: " +  item.payload.doc.data().name )
          //console.log(" item.payload.doc.data().belongsToProduct: " +  item.payload.doc.data().belongsToProduct )

          if (!item.payload.doc.data().annuity) {
            let event = new Event();
            event.id = item.payload.doc.id;
            event.name = item.payload.doc.data().name;
            event.key = item.payload.doc.data().key || '';
            event.master = item.payload.doc.data().master || false;
            event.belongsToProduct = item.payload.doc.data().belongsToProduct || false;
            event.location = item.payload.doc.data().location;
            event.location_id = item.payload.doc.data().location_id || '';
            event.context_id = item.payload.doc.data().context_id || '';
            event.text = item.payload.doc.data().text;
            event.deleted = item.payload.doc.data().deleted;
            event.congress = item.payload.doc.data().congress;
            event.materials = item.payload.doc.data().materials;
            event.limit_per_member = item.payload.doc.data().limit_per_member;

            event.control_ticket_by_topic = item.payload.doc.data().control_ticket_by_topic;

            event.docUsers = item.payload.doc.data().docUsers;
            event.docUserTop = item.payload.doc.data().docUserTop;
            event.docUserLeft = item.payload.doc.data().docUserLeft;

            event.docStaff = item.payload.doc.data().docStaff;

            event.sponsors = item.payload.doc.data().sponsors;

            event.urlQRCodeUser = item.payload.doc.data().urlQRCodeUser;
            event.urlQRCodeStaff = item.payload.doc.data().urlQRCodeStaff;

            event.image_web = item.payload.doc.data().image_web;
            event.image_mobile = item.payload.doc.data().image_mobile;

            if (item.payload.doc.data().startDay) {
              let dtStart: any = item.payload.doc.data().startDay
              event.startDay = new Date(dtStart.seconds * 1000);
            }
            return event;
          }
        });

        this.eventDataSource = new MatTableDataSource(array);

      })
  }

  selectEventCongress () {
    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('congress', '==', true)
      .where('deleted', '==', false)
    ).snapshotChanges()
  }

  load () {
    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('congress', '==', true)
      .orderBy('name', 'asc')
    ).snapshotChanges();
  }

  loadEvents () {
    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('deleted', '==', false)
      .orderBy('name', 'asc')
    ).snapshotChanges();
  }

  loadEventsCongresses (isCongress: boolean) {
    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('deleted', '==', false)
      .where('congress', '==', isCongress)
      .orderBy('name', 'asc')
    ).snapshotChanges();
  }

  async loadEventsArchived (isCongress: boolean) {

    try {
      const array: any = [];
      const querySnapshot = await this.db.collection<any>('sbccv_events', ref => ref
        .where('congress', '==', isCongress)
        .orderBy('name', 'asc'))
        .get()
        .toPromise();

      querySnapshot.forEach(doc => {
        if (doc.data().docStaff || doc.data().docUsers) {
          const data: any = {
            "id": doc.id,
            "name": doc.data().name,
            "startDay":this.formatDate(doc.data().startDay),
            "docStaff": doc.data().docStaff,
            "urlQRCodeStaff": doc.data().urlQRCodeStaff,
            "docUsers": doc.data().docUsers,
            "urlQRCodeUser": doc.data().urlQRCodeUser,
          }
          array.push(data);
        }
      });

      return array;

    } catch (error) {
      console.error("Erro ao buscar eventos", error);
    }

  }

    formatDate (date: any) {
    if (date) {
      let d: any = date
      date = new Date(d.seconds * 1000)
      let dt = date.toISOString()
      let dd: any = dt.substr(8, 2);
      let mm: any = dt.substr(5, 2);
      let yy: any = dt.substr(0, 4);
      return dd + "/" + mm + "/" + yy

    } else {
      return ""
    }
  }

  compareNames (a, b) {

    const pa = String(a.name)
    const pb = String(b.name)

    if (pa > pb) return 1;
    if (pb > pa) return -1;
    return 0;

  }

  selectById (id) {
    this.itemDoc = this.db.doc<Event>('sbccv_events/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item
  }

  getById (id) {
    return this.db.doc<Event>('sbccv_events/' + id)
      .get();
  }

  loadAllEvents () {
    return this.db.collection<Event>('sbccv_events', ref => ref
      .where('deleted', "==", false)).snapshotChanges()
      .subscribe((result) => {
        this.arrayAllEvents = result.map(item => {
          let event: any = {};
          event.id = item.payload.doc.id;
          event.name = item.payload.doc.data().name;
          return event;
        });

        this.arrayAllEvents.sort(this.compareNames)

      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Error load events", '', 'error');
        })
  }

  insert (event): any {
    this.spinner = true;
    return this.db.collection('sbccv_events').add(Object.assign({}, event))
      .then((result) => {
        this.isEdit = true;
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
        return result
      })
      .catch((error) => {
        console.log("insert event error: " + error)
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });
  }

  update (event: Event) {
    this.spinner = true;
    // console.log("event: " + JSON.stringify(entity))
    return this.db.collection('sbccv_events').doc(event.id).set(Object.assign({}, event), {'merge': true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("event update error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false
      });

  }

  updateImages () {

    if (this.objectImage_web) {
      this.uploadImage_web(this.objectImage_web, this.currentEvent.id)
    } else {
      this.snackBar.openSnackBar("Sucesso!", '', 'success');
    }

    if (this.objectImage_mobile) {
      this.uploadImage_mobile(this.objectImage_mobile, this.currentEvent.id)
    } else {
      this.snackBar.openSnackBar("Sucesso!", '', 'success');
    }
  }

  canDeleteEvent (id: string) {

    return this.db.collection("sbccv_product_itens").ref
      .where("event_id", "==", id)
      .limit(1)
      .get()
      .then(async (querySnapshot) => {

        const prodPromise = new Promise((resolve) => {

          if (querySnapshot.empty) {

            resolve(true)

          } else {

            const docArray: any[] = querySnapshot.docs
            const product_id = docArray[ 0 ].data().product_id

            console.log("product_id: " + product_id)

            return this._productService.getById(product_id)
              .subscribe((ret) => {
                const retProd: any = ret.data()

                console.log("retProd.deleted: " + JSON.stringify(retProd.deleted))

                if (retProd.deleted) {
                  console.log("pode apagar")
                  resolve(true)
                } else {
                  console.log("não pode apagar")
                  resolve(false)
                }

              })
          }
        })
        return (await Promise.all([ prodPromise ]));

      })
      .catch((err) => {
        console.log("canDeleteEvent error: " + err.message)
      });

  }

  delete (id: string) {

    //in fact, is an update
    this.spinner = true;

    return this.db.collection('sbccv_events').doc(id).set({deleted: true}, {merge: true})
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("erro delete event: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  undo (id: string) {

    this.spinner = true;

    return this.db.collection('sbccv_events').doc(id).set({deleted: false}, {merge: true})
      .then((e) => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("erro delete event: " + error)
        this.snackBar.openSnackBar("Erro!", '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }


  createEvent (data: any): Event {

    let event = new Event()

    event.id = data.id ? data.id : "";
    event.name = data.name;
    event.key = data.key ? data.key : "";

    event.annuity = false;

    event.congress = data.congress;

    if (data.congress) {
      //é parte de um congresso e depende de como foi editado
      event.belongsToProduct = data.belongsToProduct
      event.master = data.master ? data.master : false;
    } else {
      // é um evento e qualquer evento pode ser referenciado em um produto
      event.belongsToProduct = true;
      event.master = true;
    }

    event.location = data.location ? data.location : "";
    event.location_id = data.location_id ? data.location_id : "";
    //
    event.context_id = data.context_id ? data.context_id : "";
    //   event.team = data.team;
    event.text = data.text;
    event.limit_per_member = Number(data.limit_per_member);

    if (!this.isEdit) {
      event.deleted = false
    }

    event.docUsers = data.docUSers ? data.docUSers : ""
    event.docUserTop = data.docUserTop ? Number(data.docUserTop) : 0
    event.docUserLeft = data.docUserLeft ? Number(data.docUserLeft) : 0

    event.docStaff = data.docStaff ? data.docStaff : ""
    event.docStaffTop = data.docUserTop ? Number(data.docStaffTop) : 0
    event.docStaffLeft = data.docUserLeft ? Number(data.docStaffLeft) : 0

    event.urlQRCodeUser = data.urlQRCodeUser ? event.urlQRCodeUser : ""
    event.urlQRCodeStaff = data.urlQRCodeStaff ? event.urlQRCodeStaff : ""

    event.startDay = data.startDay;

    event.control_ticket_by_topic = data.control_ticket_by_topic ? data.control_ticket_by_topic : false;

    event.sponsors = data.sponsors ? data.sponsors : [];

    event.image_mobile = data.image_mobile;
    event.image_web = data.image_web;


    return event;
  }

  createForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      key: new FormControl(''),
      master: new FormControl(''),
      belongsToProduct: new FormControl(''),
      location: new FormControl(''),
      location_id: new FormControl(''),
      context_id: new FormControl(''),
      congress: new FormControl(''),
      //   team: new FormControl(''),
      text: new FormControl(''),
      limit_per_member: new FormControl('', [ Validators.required ]),
      days: new FormControl(''),

      docUsers: new FormControl(''),
      docUserTop: new FormControl(''),
      docUserLeft: new FormControl(''),

      docStaff: new FormControl(''),
      docStaffTop: new FormControl(''),
      docStaffLeft: new FormControl(''),

      urlQRCodeUser: new FormControl(''),
      urlQRCodeStaff: new FormControl(''),

      startDay: new FormControl('', [ Validators.required ]),
      control_ticket_by_topic: new FormControl(''),

      image_web: new FormControl(''),
      image_mobile: new FormControl(''),

    });

    if (data) {
      form.controls.id.setValue(data.id);
      form.controls.name.setValue(data.name);
      form.controls.key.setValue(data.key);
      form.controls.master.setValue(data.master);
      form.controls.belongsToProduct.setValue(data.belongsToProduct);
      form.controls.location.setValue(data.location);
      form.controls.location_id.setValue(data.location_id);
      form.controls.context_id.setValue(data.context_id);
      form.controls.congress.setValue(data.congress);
      form.controls.text.setValue(data.text || "");
      form.controls.limit_per_member.setValue(data.limit_per_member);
      form.controls.days.setValue(data.days);
      form.controls.docUsers.setValue(data.docUsers);
      form.controls.docUserTop.setValue(data.docUserTop);
      form.controls.docUserLeft.setValue(data.docUserLeft);
      form.controls.docStaff.setValue(data.docStaff);
      form.controls.docStaffTop.setValue(data.docStaffTop);
      form.controls.docStaffLeft.setValue(data.docStaffLeft);
      form.controls.startDay.setValue(data.startDay);
      form.controls.control_ticket_by_topic.setValue(data.control_ticket_by_topic);

      form.controls.urlQRCodeUser.setValue(data.urlQRCodeUser);
      form.controls.urlQRCodeStaff.setValue(data.urlQRCodeStaff);

      form.controls.image_web.setValue(data.image_web);
      form.controls.image_mobile.setValue(data.image_mobile);

    }
    return form
  }

  makeEvent (item: any) {
    let event = new Event();
    event.id = item.id;
    event.name = item.data().name;
    event.location = item.data().location;
    event.location_id = item.data().location_id || '';
    event.key = item.data().key || '';

    event.congress = item.data().congress;
    event.master = item.data().master || false;
    event.belongsToProduct = item.data().belongsToProduct || false;

    event.text = item.data().text;
    event.deleted = item.data().deleted;

    event.materials = item.data().materials;
    event.limit_per_member = item.data().limit_per_member;

    event.control_ticket_by_topic = item.data().control_ticket_by_topic;

    event.docUsers = item.data().docUsers;
    event.docUserTop = item.data().docUserTop;
    event.docUserLeft = item.data().docUserLeft;

    event.docStaff = item.data().docStaff;

    event.sponsors = item.data().sponsors;

    event.urlQRCodeUser = item.data().urlQRCodeUser;
    event.urlQRCodeStaff = item.data().urlQRCodeStaff;

    if (item.data().startDay) {
      let dtStart: any = item.data().startDay
      event.startDay = new Date(dtStart.seconds * 1000);
    }

    return event
  }

  breadCrumb (value) {

    if (value) {
      if (value.length > 150) {
        return value.substr(0, 100) + " ..."
      } else {
        return value
      }
    }

  }

  makeMsgError (errorsCode) {
    /*
    let msgError: string
        switch (errorsCode) {
          case "auth/email-already-exists":
            msgError = "Este email já está em uso"
            break;
        }
        return msgError
    */
    return errorsCode
  }

  uploadFilePdf (file, label) {
    this.spinner = true;

    const key = Guid.create() + ".pdf";
    const fsRef: AngularFireStorageReference = this.fs.ref("events/pdfs/" + key + ".pdf");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          console.log("uploaded.")
          this.spinner = false;
          this.updateFilePdfUrl(key, file, url, label)
        });
      }))
      .subscribe();

  }

  updateFilePdfUrl (key: any, file: any, url: any, data: any) {
    this.spinner = true;

    if (!this.currentEvent.materials) {
      this.currentEvent.materials = []
    } else {
      this.currentEvent.materials = this.currentEvent.materials.filter((e) => {
        return e.id != key
      })
    }

    const pdf = new FileMaterial()
    pdf.id = key
    pdf.name = data.name
    pdf.original = file.name
    pdf.storage = url

    this.currentEvent.materials.push(pdf)

    return this.db.collection('sbccv_events').doc(this.currentEvent.id)
      .set(JSON.parse(JSON.stringify({materials: this.currentEvent.materials})), {merge: true})
      .then(() => {

        this.setPdfDataSource()
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("event update pdf  error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })


  }

  createPdfForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      original: new FormControl('', [ Validators.required ]),
      storage: new FormControl(''),
      url: new FormControl(''),
    });

    return form
  }

  setDocUsers (event) {

    if (event.target.files.length === 0) {
      return;
    }
    this.docUsers = event.target.files[ 0 ];
  }


  updateTopLeftQrcodeUser (docUserTop: number, docUserLeft: number, urlQRCodeUser: string) {
    this.spinner = true;

    return this.db.collection('sbccv_events').doc(this.currentEvent.id)
      .set({
        'docUserTop': docUserTop,
        'docUserLeft': docUserLeft,
        'urlQRCodeUser': urlQRCodeUser
      }, {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("event update top, left qtcode error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  uploadDocUsers (file: any) {
    this.spinner = true;

    const key = this.currentEvent.id + "_docUsers"
    const fsRef: AngularFireStorageReference = this.fs.ref("/certificates/docs/" + key + ".docx");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.spinner = false;
          this.updateDocUsers(url)
        });
      }))
      .subscribe();

  }

  updateDocUsers (url: any) {
    this.spinner = true;

    return this.db.collection('sbccv_events').doc(this.currentEvent.id)
      .set({"docUsers": url}, {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("event update docUSers error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  setDocStaff (event) {

    if (event.target.files.length === 0) {
      return;
    }
    this.docStaff = event.target.files[ 0 ];
  }

  updateTopLeftQrcodeStaff (docStaffTop: number, docStaffLeft: number, urlQRCodeStaff: string) {
    this.spinner = true;

    return this.db.collection('sbccv_events').doc(this.currentEvent.id)
      .set({
        'docStaffTop': docStaffTop,
        'docStaffLeft': docStaffLeft,
        'urlQRCodeStaff': urlQRCodeStaff
      }, {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("event update top, left qtcode staff error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  uploadDocStaff (file) {
    this.spinner = true;

    const key = this.currentEvent.id + "_docStaff"
    const fsRef: AngularFireStorageReference = this.fs.ref("/certificates/docs/" + key + ".docx");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          console.log("uploaded.")
          this.spinner = false;
          this.updateDocStaff(url)
        });
      }))
      .subscribe();

  }

  updateDocStaff (url: any) {
    this.spinner = true;

    return this.db.collection('sbccv_events').doc(this.currentEvent.id)
      .set({"docStaff": url}, {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("event update docStaff error: " + JSON.stringify(error))
        let msgError: string = this.makeMsgError(error.details.code)
        this.snackBar.openSnackBar(msgError, '', 'error');
      })
      .finally(() => {
        this.spinner = false;
      })
  }

  updateBannerSponsor (event_id, banners) {

    //console.log("event_id: " + event_id)
    // console.log("banners: " + JSON.stringify(banners))

    return this.db.collection('sbccv_events').doc(event_id).set(Object.assign({}, {'sponsors': banners}), {merge: true})
      .then(() => {
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((error) => {
        console.log("event update banner error: " + JSON.stringify(error))
        this.snackBar.openSnackBar("Erro", '', 'error');
      })

  }

  previewImage_web (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage_web = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage_web = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImage_web (file, event_id) {

    const fsRef: AngularFireStorageReference = this.fs.ref("images/event/agenda/" + event_id + "_web" + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage_web(event_id, url)
        });
      }))
      .subscribe();
  }

  updateImage_web (event_id: any, image: any) {
    return this.db.collection('sbccv_events').doc(event_id).set({image_web: image}, {merge: true})
      .then(() => {
        this.objectImage_web = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

  previewImage_mobile (event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[ 0 ].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage_mobile = event.target.files[ 0 ];
    reader.readAsDataURL(event.target.files[ 0 ]);
    reader.onload = (_event) => {
      this.storedImage_mobile = reader.result;
      return event.target.files[ 0 ];
    }
  }

  uploadImage_mobile (file, event_id) {

    const fsRef: AngularFireStorageReference = this.fs.ref("images/event/agenda/" + event_id + "_mobile" + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage_mobile(event_id, url)
        });
      }))
      .subscribe();
  }

  updateImage_mobile (event_id: any, image: any) {
    return this.db.collection('sbccv_events').doc(event_id).set({image_mobile: image}, {merge: true})
      .then(() => {
        this.objectImage_web = ""
        this.snackBar.openSnackBar("Sucesso!", '', 'success');
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }

}
